import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import './NotFound.css';

function Unauthorized() {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser, isApproved, userRoles } = useAuth();
  const { t } = useLanguage();

  const isAdmin = userRoles && userRoles.includes('admin');
  const isLoggedIn = !!currentUser;
  const isLoggedInButNotApproved = isLoggedIn && !isAdmin && !isApproved;

  const goToLogin = () => {
    // If user is already logged in, don't go to login (which might redirect them back)
    // Instead, go to home or stay here
    if (isLoggedIn) {
      navigate('/', { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  };

  const goHome = () => {
    navigate('/', { replace: true });
  };

  const goToProfile = () => {
    navigate('/profile', { replace: true });
  };

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1 className="not-found-title">401</h1>
        <p className="not-found-message">
          {t('unauthorized.title') || 'Access Denied'}
        </p>
        <p className="not-found-redirect">
          {isLoggedInButNotApproved
            ? (t('unauthorized.messageNotApproved') || 'Your account is pending approval. Please wait for admin approval before accessing this page.')
            : (t('unauthorized.message') || 'You must verify your email before accessing this page.')}
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          {!isLoggedIn ? (
            <>
              <button className="not-found-button" onClick={goToLogin}>
                {t('unauthorized.goToLogin') || 'Go to Login'}
              </button>
              <button className="not-found-button" onClick={goHome}>
                {t('unauthorized.goHome') || 'Go Home'}
              </button>
            </>
          ) : (
            <>
              <button className="not-found-button" onClick={goHome}>
                {t('unauthorized.goHome') || 'Go Home'}
              </button>
              <button className="not-found-button" onClick={goToProfile}>
                {t('unauthorized.goToProfile') || 'Go to Profile'}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Unauthorized;


